export default __webpack_public_path__ + "static/media/explore7.4784dc39.png";